export default "__VITE_ASSET__DLFEtfmA__"